import { createContext } from "react";




export const refContext = createContext()